import React from "react";
import { useSelector } from "react-redux";
import { connect } from "react-redux";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Navbar from "components/navbar";
import Sidebar from "components/sidebar";
import routes from "routes.js";
import { getActiveNavbar, getRoutes, getActiveRoute, filterRoutes } from "../../utils";
import ChatEli from "components/ai/ChatEli";

const Console = ({isCollapse, ...props}) => {
  const { ...rest } = props;
  const location = useLocation();
  const [open, setOpen] = React.useState(true);

  const user = useSelector((state) => state.auth.user);
  const modules = useSelector((state) => state.auth.modules);
  const allowedRoutes = React.useMemo(
		() => filterRoutes(routes, user?.user_level, modules),
		[user?.user_level, modules]
	);

  React.useEffect(() => {
    window.addEventListener("resize", () =>
      window.innerWidth < 1200 ? setOpen(false) : setOpen(true)
    );
  }, []);

  React.useEffect(() => {
    getActiveRoute(routes, location.pathname, );
  }, [location.pathname, getActiveRoute]);

  document.documentElement.dir = "ltr";
  return (
    <div className={`flex h-full w-full bg-white console-gradient-bg ${isCollapse ? 'collapsed' : 'expanded'}`}>
      <div className="page-bg-primary console-gradient-bg fixed h-screen w-screen "/>
      <Sidebar open={open} onClose={() => setOpen(false)} routes={allowedRoutes}/>
      {/* Navbar & Main Content */}
      <div className="h-full w-full">
        {/* Main Content */}
        {/* <ChatEli /> */}
        <main
          className={`h-full flex-none transition-all xl:ml-[255px]`}
        >
          {/* Routes */}
          <div className="h-full">
            <Navbar
              onOpenSidenav={() => setOpen(true)}
              logoText={"Intsamis"}
              secondary={getActiveNavbar(allowedRoutes)}
              allowedRoutes={allowedRoutes}
              {...rest}
            />
            <div className="p-3 sm:p-4 md:p-6 flex-1 mx-auto mb-auto h-full min-h-[84vh]">
              <Routes>
                {getRoutes(allowedRoutes)}

                <Route
                  path="/"
                  element={<Navigate to="/console/dashboard" replace />}
                />
              </Routes>
            </div>
            
            <div className="p-3">
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
	isCollapse: state.layout.isSideMenuCollapse,
});

const mapDispatchToProps = (dispatch) => ({
	
});

export default connect(mapStateToProps, mapDispatchToProps)(Console);
